import axios from 'axios';

const API_Url = 'http://w-s/';

export default {
  actions: {
    // Админ по айди

    GetAdminByID({commit}, AdminID) {
      axios.get(API_Url + 'admin.get?admin_id=' + AdminID)
        .then((response) => {
          const AdminRes = response.data.response;
          commit('AdminByIDMut', AdminRes)
        })
        .catch(error => {
          const Error = error.message;
          commit('AdminErrorMut', Error)
        });
    },
  },
  mutations: {
    AdminByIDMut(state, AdminRes) {
      state.Admins.Admin = AdminRes;
    },

    AdminErrorMut(state, Error) {
      state.Admins.Error = Error;
    },
  },
  state: {
    Admins: {
      Error: [],
      Admin: []
    },
  },
  getters: {
    AdminByIDGet(state) {
      return state.Admins.Admin;
    },

    AdminErrorGet(state) {
      return state.Admins.Error;
    },
  }
}
